<template>
  <div class="basic register-entrance">
    <div class="basic-header">
      <p>- 展会选择/Exhibition selection -</p>
    </div>

    <div class="choice">
      <Row :gutter="40">
        <Col span="24">
          <div class="select-box group1">
            <div class="select-content">
              <!-- @on-change="changeExId" -->
              <RadioGroup @on-change="changeExId" v-model="exhibitionSelectId">
                <template>
                  <Row>

                  <Col v-if="false" span="12" style="margin-bottom: 26px" class="myRadio">
                      <Radio label="a97ac797-41c4-4890-971d-a2191d6a1b61"
                        ><span class="fontWeight"
                          >第92届全国药品交易会(2026年05月13日-15日 上海)</span
                        ></Radio
                      >
                    </Col>


                    <Col span="12" style="margin-bottom: 26px" class="myRadio">
                      <Radio label="e498745b-01d7-4931-8179-fb1a4eab5c9a"
                        ><span class="fontWeight"
                          >第93届全国药品交易会(2026年10月21日-23日 北京)</span
                        ></Radio
                      >
                    </Col>

                    <Col span="12" style="margin-bottom: 26px" class="myRadio">
                      <Radio label="f296228f-3cfb-411a-b06f-34a66b6e7a1f"
                        ><span class="fontWeight"
                          >第94届全国药品交易会(2027年05月19日-21日广州)</span
                        ></Radio
                      >
                    </Col>

                  
                  </Row>
                </template>
              </RadioGroup>
            </div>
          </div>
        </Col>
      </Row>
    </div>
    <div class="basic-header" v-if="area1.length > 0">
      <p>- 展区选择/Select Exhibition & Booth -</p>
    </div>

    <div class="choice"  style="width: 1200px !important;" v-if="area1.length > 0">
      <Row :gutter="40">
        <Col span="24">
          <div class="select-box group1">
            <div class="select-content">
              <!-- <RadioGroup v-model="areaName" vertical @on-change="changeArea"> -->
              <RadioGroup v-model="areaName" vertical @on-change="changeRadio">
                <template>
                  <Row>
                    <template v-if="!isZh">
                      <template v-for="(item, index) in area1">
                        <Col
                          span="6"
                          style="margin-bottom: 26px"
                          :key="index"
                          v-if="item.name.includes('海外品牌展区')"
                          class="myRadio"
                        >
                          <Radio :label="item.name" v-bind:key="index"
                            ><span class="fontWeight">{{ item.name }}</span></Radio
                          >
                        </Col>
                      </template>
                    </template>

                    <template v-if="isZh">
                      <template v-for="(item, index) in area1">
                        <!-- 根据showIndex排序显示  前四个显示在第一行 -->
                        <!-- v-if="item.showIndex < 4" -->

                        <!-- 如果item.name==高增长渠道专区-新零售   给这个区域加上样式 position: relative;left: -274px;-->

                        <p  v-if="index < 4">
                            <Col
                            :span="item.displayOrder == 1? 12 : 6"
                            style="margin-bottom: 26px;"
                            :key="index"
                            class="myRadio"
                            >
                            <!-- :style="item.name == '高增长渠道专区-新零售' ? 'position: relative; left: -275px;' : ''" -->

                                <Radio :label="item.name" v-bind:key="index"
                                    ><span class="fontWeight"><img v-if="item.displayOrder == 1" style='width: 20px;position: relative;top: 5px;' src='https://oss-ecrm.reed-sinopharm.com/myexpocloud/image/202507/31/LY593TQ7_0d8312ba-2643-4649-bf3a-46ed7d68ac2a.png'/>{{ item.name }}</span></Radio
                                >
                            </Col>

                        </p>

                        <p v-else style="margin-bottom: 25px" v-bind:key="index" >
                          <Radio :label="item.name">
                            <span class="fontWeight">{{ item.name }}</span>
                            <span v-if="item.name == '医药研发供应链'"
                              >（研发服务、CRO 、CMO 、CDMO、MAH合作、注册咨询）
                            </span>
                            <span v-if="item.name == '个人护理用品'"
                              >（湿巾类、棉柔巾、洁面巾、口腔护理、洗涤清洁、消杀防护、香氛精油、母婴护理、个护美健电器、OEM/ODM及其他关联产品）
                            </span>

                            <span v-if="item.name == '中药材/中药饮片'"
                              >（大宗饮片、传统饮片、精致包装饮片、小包装饮片、直接口服固体饮片、破壁饮片、药食同源中药材及花草茶、中药配方颗粒、新型中药饮片、中药材、中药饮片生产设备、中药饮片包装等）</span
                            >
                            <span v-if="item.name == '中医药养生'"
                              >（艾灸及艾产品、中医养生馆、足浴足疗药浴产品、中式药油/药膏、药膳、养生酒等）</span
                            >
                            <span v-if="item.name == '中医诊疗及中医药设备'"
                              >（中医诊疗设备、中医器械、中药设备等）</span
                            >
                            <span v-if="item.name == '医美融合产品'"
                              >（填充注射产品、美容抗衰仪器及设备、皮肤美容产品及技术、术后修复产品、中医美容产品、口服美容产品、智慧医美及康养体系、口腔整形耗材等）</span
                            >
                            <span v-if="item.name == '医美健康'"
                              >（术后医用修复及敷料类产品、功效性修护及护肤产品、注射填充产品、声光电仪器及设备、中医美容产品、口服美容产品、智慧医美及康养体系、口腔整形耗材等）</span
                            >
                            <span v-if="item.name == 'AI智慧医药'"
                              >（B2B、B2C、O2O等电商平台、健康管理平台、AI辅助诊断系统、AI医药/医疗智能服务、智能药柜、医药互联网信息技术服务等）</span
                            >
                            <span v-if="item.name == '医药物流技术与设备'"
                              >（仓储搬运、运输配送、冷链服务、智能设备等）</span
                            >
                            <span v-if="item.name == '智慧营销'"
                              >（医学服务、数字营销、专项技术、品牌提示、培训咨询、市场调研、品牌设计等）</span
                            >
                            <span v-if="item.name == 'NHNE中国国际健康营养博览会'"
                              >（特殊营养食品、保健食品（蓝帽子）、膳食补充剂）</span
                            >
                            <span v-if="item.name == '医用耗材'"
                              >（喷剂、凝胶、洗液、膏药、理疗贴、退热贴、热敷贴、IVD试纸等）</span
                            >
                            <span v-if="item.name == '卫生材料'"
                              >（口罩、手套、护理垫、创面损伤敷料、手术用品、粘贴材料、护创材料、医用纺织品等）</span
                            >
                            <span v-if="item.name == '家用医疗器械'"
                              >（血压计、血糖仪、体温计、听诊器、胎心仪、体重秤、呼吸机、制氧机、雾化仪）</span
                            >
                            <span v-if="item.name == '成人用品'"
                              >（安全避孕用品、功能性情趣用品等）</span
                            >
                            <span v-if="item.name == '中医诊疗'"
                              >（中医诊疗设备、中医器械）</span
                            >
                            <span v-if="item.name == '康复辅助器具'"
                              >（护具、支具、轮椅、压力袜等 ）
                            </span>
                          </Radio>
                        </p>

                        <!-- <Col span="6" style="margin-bottom: 26px" :key="index" v-if="item.name.length < 18" class="myRadio">
                    <Radio :label="item.name"></Radio>
                    </Col>
                    <Col span="24" style="margin-bottom: 26px" :key="index" v-else class="myRadio">
                    <Radio :label="item.name"></Radio>
                    </Col> -->
                      </template>
                    </template>
                  </Row>
                </template>
              </RadioGroup>
            </div>
          </div>
        </Col>
      </Row>
    </div>
    <div class="basic-header" v-if="selectArea.length">
      <p>- 展位选择/Space Type -</p>
    </div>
    <!-- shellInfo:{{shellInfo}} <br />
    RawInfo:{{RawInfo}} <br /> -->
    <div class="choice" v-if="selectArea.length">
      <div class="select-box">
        <div class="select-content" style="padding: 30px 40px">
          <Row>
            <Col span="12">
              <div class="top">
                <div class="top-title">
                  特装展位/Raw Space<span class="top-txt2"> (18m²起订/minimum ) </span>
                </div>
                <RadioGroup v-model="shellInfo" @on-change="changeType">
                  <div
                    class="top-item"
                    v-for="(item, index) in shellArr"
                    :key="'shell-' + index"
                  >
                    <Radio :label="item.id" style="width: 270px"
                      >{{ item.name }} {{ item.price }}元/m²</Radio
                    >
                    <InputNumber
                      :max="9999"
                      :min="0"
                      v-model="item.count"
                      style="width: 80px"
                      :disabled="!(shellInfo && shellInfo === item.id)"
                    >
                    </InputNumber>

                    <span style="padding-left: 10px">ｍ² </span>
                  </div>
                </RadioGroup>
              </div>
            </Col>
            <Col span="12">
              <div class="top">
                <div class="top-title">
                  标准展位/Standard Booth<span class="top-txt2"
                    >(规格/per unit9m²/个)</span
                  >
                </div>
                <RadioGroup v-model="RawInfo" @on-change="changeType2">
                  <div
                    class="top-item"
                    v-for="(item, index) in RawArr"
                    :key="'raw-' + index"
                  >
                    <Radio :label="item.id" style="width: 270px"
                      >{{ item.name }} {{ item.price }}元/个</Radio
                    >
                    <InputNumber
                      :max="9999"
                      :min="0"
                      v-model="item.count"
                      style="width: 80px"
                      :disabled="!(RawInfo && RawInfo === item.id)"
                    >
                    </InputNumber>
                    <span style="padding-left: 10px">个 </span>
                  </div>
                </RadioGroup>
              </div>
            </Col>
          </Row>
          <div>
            <Checkbox v-model="isNeedUpdate">如需要进行“标改特”，请勾选</Checkbox
            ><br /><br />
            <Checkbox v-model="isNeedAngular"
              >如有意预订转角位，请勾选此项。标准展位转角位置（两面开展位）加收原价格的20%</Checkbox
            >
          </div>
        </div>
      </div>
    </div>

    <!-- <div class="handle-box">
      <Button @click="validHandle" class="handle-box-btn" type="primary">提交</Button>
    </div> -->
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      isNeedUpdate: false,
      isNeedAngular: false,
      company1: "",
      productName: "",
      areaName: "",
      areaType: "",
      // 特装展位
      shellArr: [],
      // 标准展位
      RawArr: [],
      shellInfo: null,
      RawInfo: null,
      area1: [],
      selectArea: [],
      selectAreaGroupId: "",
      activityList: [],

      exhibitionSelectId: "",
    };
  },
  computed: {
    exAreasOption() {
      return {
        clientId:
          this.exhibitionSelectId == "e498745b-01d7-4931-8179-fb1a4eab5c9a" ? 37 : 34,
        // clientId: this.company1.clientId,
        languageType: "中文", // 中文|英文
      };
    },
    isZh() {
      //   console.log(this.$store.state.isZh, "this.$store.state.isZh;");
      return this.$store.state.isZh || true;
    },
  },
  watch: {
    isZh() {
      this.selectArea = [];
      this.areaName = "";
      this.shellInfo = null;
      //   console.log("isZh:", newValue);
    },

    exhibitionSelectId() {
      //   console.log("exhibitionSelectId:", newValue);
      this.area1 = [];
      this.selectArea = [];
      this.areaName = "";
      this.shellInfo = null;
      this.getExhibitionHandle();
    },
  },
  created() {
    // this.getExhibitionHandle();
  },

  methods: {
    ...mapActions({
      getApplyCompanyGetAreas: "registerdModule/getApplyCompanyGetAreas",
      getApplyCompanyGetAreasNew: "registerdModule/getApplyCompanyGetAreasNew",
      getExhibitionById: "registerdModule/getExhibitionById",

      getAllArea: "getAllArea", //获取展区列表
      getCommodities: "getCommodities", //获取商品信息
    }),
    async getExhibitionHandle() {
      sessionStorage.setItem("exhibitionSelectId", this.exhibitionSelectId);

      let res = await this.getExhibitionById(this.exhibitionSelectId);
      if (res) {
        this.company1 = res;
        // console.log("getExhibitionHandle", this.company1);
      }
      this.getApplyCompanyGetAreasHandleNew(); // 获取展区
    },

    async getApplyCompanyGetAreasHandleNew() {
      //   let res = await this.getApplyCompanyGetAreasNew(this.exAreasOption);
      let res = await this.getAllArea(this.exhibitionSelectId);
      if (res && res.length) {
        this.area1 = res;
        // console.log("area1", this.area1);
        // console.log("getApplyCompanyGetAreasHandleNew", res);
      }
    },

    async changeRadio(e) {
      this.selectAreaGroupId = this.area1.find((c) => c.name === e).id;
      let areaId = this.area1.find((c) => c.name === e).id;
      let opt = {
        areaId: areaId,
        exhibitionId: this.exhibitionSelectId,
        isEnable: true,
      };

      let arr = await this.getCommodities(opt);

      this.RawArr = [];
      this.shellArr = [];

      setTimeout(() => {
        // this.area1.map((c) => {
        //   if (c.name === e) {
        //     arr = c.pjNames || [];
        //   }
        // });
        arr.map((c) => {
          c.count = 0;
        });
        arr.forEach((v) => {
          if (v.boothKind === "标展") {
            this.RawArr.push(v);
          } else if (v.boothKind === "特装") {
            this.shellArr.push(v);
          }
        });
        this.selectArea = arr;
        this.shellInfo = null;
        this.RawInfo = null;
        // console.log("标准展位", this.RawArr);
        // console.log("特装展位", this.shellArr);
      }, 100);
    },

    async validHandle() {
      // console.log(this.shellInfo,'this.shellInfo');
      if (!this.exhibitionSelectId) {
        this.$Message.error("请选择展会");
        return Promise.resolve({ valid: false });
      }
      if (!this.areaName) {
        this.$Message.error("请选择展区");
        return Promise.resolve({ valid: false });
      }
      if (!(this.RawInfo || this.shellInfo)) {
        this.$Message.error("请选择展位/Please select booth");
        return Promise.resolve({ valid: false });
      }
      let areaType = ""; // 展位类型 光地|标展
      let showArea = 0; // 展位类型为光地时 输入的展位面积
      let hallCount = 0; // 展位类型为标展时 输入的标展个数
      let selectType = null;
      if (this.shellInfo) {
        this.shellArr.forEach((c) => {
          if (c.id === this.shellInfo) {
            areaType = c.boothKind;
            showArea = c.count;
            selectType = c;
          }
        });
      }
      if (this.RawInfo) {
        this.RawArr.forEach((c) => {
          if (c.id === this.RawInfo) {
            areaType = c.boothKind;
            hallCount = c.count;
            selectType = c;
          }
        });
      }
      //   console.log("areaType", areaType);
      //   console.log("showArea", showArea);
      //   console.log("hallCount", hallCount);
      //   console.log("selectType", selectType);
      if (areaType) {
        if (areaType === "特装" && showArea < 18) {
          this.$Message.error(
            "请输入光地展位的面积(18㎡起订)/Please enter the size of the booth"
          );
          return Promise.resolve({ valid: false });
        }
        if (areaType === "标展" && !hallCount) {
          this.$Message.error(
            "请输入标准展位的个数/Please enter the number of standard booth"
          );
          return Promise.resolve({ valid: false });
        }
      } else {
        this.$Message.error("请选择您预定的展位/Please select the booth");
        return Promise.resolve({ valid: false });
      }
      if (areaType === "标展") {
        showArea = hallCount * 9;
      }
      let order = {
        exhibitionId: this.company1.id,
        showArea: showArea,
        pType: selectType.pType,
        areaType: areaType,
        areaName: this.areaName,
        hallCount: hallCount,
        AllMoney: selectType.price * hallCount,
        ApplyBoothOrder: {
          boothType: selectType.boothKind,
          boothKind: selectType.boothKind,
          unit: selectType.unit,
          dePjNameGroupId: this.selectAreaGroupId,
          thirdPartyCommodityId: selectType.id,
          gpName: selectType.gpName,
          groupId: selectType.groupId,
          dePjNameGroupName: this.areaName,
          pjCode: selectType.pjCode,
          pjFormat: selectType.pjFormat,
          unitPrice: selectType.price,
          monetaryUnit: "RMB",
          name: selectType.name,
          area: showArea,
        },
      };
      let res = {
        isNeedUpdate: this.isNeedUpdate,
        isNeedAngular: this.isNeedAngular,
        ApplyCompanyOrderNewDto: order || {},
        exhibition: this.company1,
      };
      //   console.log(res,'传值船只');
      return Promise.resolve({ valid: true, ...res });
    },
    changeType() {
      this.RawInfo = "";
      setTimeout(() => {
        let arr1 = [...this.shellArr];
        let arr2 = [...this.RawArr];
        arr1.map((e) => {
          e.count = 0;
        });
        arr2.map((e) => {
          e.count = 0;
        });
        this.shellArr = [...arr1];
        this.RawArr = [...arr2];
        // console.log("shellArr", this.shellArr);
        // console.log("RawArr", this.RawArr);
      }, 200);
    },
    changeType2() {
      this.shellInfo = null;
      setTimeout(() => {
        let arr1 = [...this.shellArr];
        let arr2 = [...this.RawArr];
        arr1.map((e) => {
          e.count = 0;
        });
        arr2.map((e) => {
          e.count = 0;
        });
        this.shellArr = [...arr1];
        this.RawArr = [...arr2];
        // console.log("shellArr", this.shellArr);
        // console.log("RawArr", this.RawArr);
      }, 200);
    },
    changeArea(e) {
      //   console.log("changeArea", e);
      this.selectAreaGroupId = e.id;
      //   console.log("selectAreaGroupId", this.selectAreaGroupId);
      let arr = [];
      this.RawArr = [];
      this.shellArr = [];
      setTimeout(() => {
        this.area1.map((c) => {
          if (c.name === e) {
            arr = c.pjNames || [];
          }
        });
        arr.map((c) => {
          c.count = 0;
        });
        arr.forEach((v) => {
          if (v.boothKind === "标展") {
            this.RawArr.push(v);
          } else if (v.boothKind === "光地") {
            this.shellArr.push(v);
          }
          //   if (v.boothKind === "标展" && (this.isZh ? v.groupId == 1 : v.groupId == 2)) {
          //     this.RawArr.push(v);
          //   } else if (
          //     v.boothKind === "光地" &&
          //     (this.isZh ? v.groupId == 1 : v.groupId == 2)
          //   ) {
          //     this.shellArr.push(v);
          //   }
        });
        this.selectArea = arr;
        this.shellInfo = null;
        this.RawInfo = null;
        // console.log("selectArea", this.selectArea);
        // console.log("标准展位", this.RawArr);
        // console.log("特装展位", this.shellArr);
      }, 100);
    },
    // changeInput(e, index, item) {
    //   console.log("e", e);
    //   console.log("index", index);
    //   console.log("item", item);
    //   console.log("RawArr", this.RawArr);
    //   console.log("shellArr", this.shellArr);
    //   },

    changeExId() {
      // console.log(this.exhibitionSelectId,'exhibitionSelectIdexhibitionSelectId');
    },
  },
};
</script>

<style lang="scss" scoped>
.basic {
  /deep/ {
    .ivu-radio-checked .ivu-radio-inner {
      border-color: #d00300 !important;
    }
    .ivu-radio-inner:after {
      background-color: #d00300;
    }
    .ivu-switch-checked {
      border-color: #d00300;
      background-color: #d00300;
    }
  }
  &-header {
    width: 100%;
    height: 64px;
    background-color: #d00300;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    p {
      line-height: 64px;
      font-size: 20px;
    }
    span {
      width: 30px;
      height: 1px;
      background-color: #fff;
      margin: 0 15px;
    }
  }
  &-title {
    font-size: 18px;
    line-height: 48px;
    background-color: #f2f2f2;
    color: #333;
    margin-bottom: 30px;
    padding-left: 30px;
    span {
      font-size: 14px;
    }
  }
}
.choice {
  margin-bottom: 30px;
}
.choicebox {
  min-height: 686px;
  background-color: #fff;
  border: solid 1px #e5e5e5;
  position: relative;
  cursor: pointer;
  overflow: hidden;
  &.active {
    background-color: #fdf7f9;
    border: solid 1px #d00300;
    .select {
      opacity: 1;
    }
    .choicebox-content ::v-deep {
      .ivu-radio-group-item {
        &:nth-child(odd) {
          background-color: #f5eff1;
        }
      }
    }
    .choicebox-tool {
      background-color: #f5eff1;
    }
  }
  .select {
    position: absolute;
    opacity: 0;
    text-align: center;
    top: 0;
    right: 0;
    width: 84px;
    height: 32px;
    line-height: 32px;
    background-color: #d00300;
    border-radius: 0px 0px 0px 10px;
    border: solid 1px #d00300;
    font-size: 14px;
    color: #fff;
  }
  &-content {
    padding: 30px;
    .title {
      text-align: center;
      font-size: 16px;
      color: #333;
      margin-bottom: 20px;
    }
    .item {
      display: flex;
      align-items: center;
      flex: 1;
      &-box {
        width: 50%;
      }
      &-box2 {
        width: 50%;
        p {
          font-size: 14px;
          color: #333;
          font-weight: normal;
        }
      }
    }
    ::v-deep {
      .ivu-radio-group-item {
        width: 100%;
        display: flex;
        align-items: center;
        min-height: 74px;
        padding: 15px 10px 15px 20px;
        &:nth-child(odd) {
          background-color: #f7f7f7;
        }
      }
    }
  }
  &-tool {
    height: 73px;
    background-color: #f7f7f7;
    padding-left: 24px;
    border-top: solid 1px #e5e5e5;
    display: flex;
    align-items: center;
  }
}
.select-box {
  .select-content {
    padding: 30px 50px;
    border: solid 1px #e5e5e5;
    border-top: none;
  }
}

.under-btn {
  ::v-deep {
    .ivu-input {
      position: relative;
      top: -5px;
      border: none;
      border-bottom: 1px solid #bfbfbf;
      border-radius: 0;
      &:hover,
      &:active {
        outline: none;
        box-shadow: none;
      }
    }
  }
}
.select-content-title {
  font-size: 16px;
  color: #333;
  margin-bottom: 18px;
}
.top {
  padding: 15px 0 0;
  color: #333;
  &-txt {
    font-size: 12px;
    padding-left: 29px;
    padding-bottom: 10px;
  }
  &-txt2 {
    color: #999;
    font-size: 14px;
  }
  &-title {
    font-size: 15px;
    margin-bottom: 28px;
  }
  &-item {
    margin-bottom: 26px;
  }
}
.bottom {
  padding: 30px;
}
.box {
  text-align: center;
  .line {
    height: 64px;
    font-size: 14px;
    color: #333;
    &:first-child {
      font-size: 16px;
      color: #fff;
      background-color: #d00300 !important;
      .ivu-col {
        border-right: 1px solid #fff;
      }
    }
    &:nth-child(odd) {
      background-color: #fff;
    }
    &:nth-child(even) {
      background-color: #f2fafe;
    }
    .ivu-col {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      border-right: 1px solid #d9f3ff;
      &:last-child {
        border-color: transparent !important;
      }
    }
  }
}
.tip {
  font-size: 12px;
  color: #333;
  line-height: 24px;
  margin-top: 30px;
}
.dot {
  position: relative;
  padding-left: 10px;
  &:before {
    content: "";
    position: absolute;
    left: 0;
    width: 4px;
    height: 4px;
    background-color: #999;
    border-radius: 50%;
    top: 10px;
    margin-top: -2px;
  }
}
.last {
  margin-bottom: 0 !important;
}

.myRadio {
  ::v-deep {
    .ivu-radio {
      padding-top: 2px;
    }
    .ivu-radio-wrapper {
      white-space: inherit;
      height: inherit;
      line-height: 1.5;
      display: flex;
    }
  }
}

.group1 .ivu-radio-group {
  width: 100%;
}
.group1 .ivu-radio-group-vertical .ivu-radio-wrapper {
  display: inline-block;
}
.group1 .ivu-radio-wrapper {
  white-space: break-spaces;
}

.fontWeight {
  font-weight: 700;
}
</style>
